import {
  AppointmentStatus,
  IAppointment,
  MedicalcareDoctor,
} from 'model/appointment';
import dayjs from 'dayjs';
import { Pharmacy } from 'model/medicare';
import { AppointmentType } from 'hooks/useAppointments';

export const getAppointmentStatus = (appointment: IAppointment) => {
  if (appointment.canceled) {
    return AppointmentStatus.CANCELED;
  }
  const paymentComplete = appointment.paidAt;
  if (paymentComplete) {
    return AppointmentStatus.PAYMENT_COMPLETED;
  }
  if (appointment.amount) {
    return AppointmentStatus.PAYMENT_PENDING;
  }
  const now = dayjs().startOf('day');
  if (!appointment.startedAt) {
    if (
      appointment.startedAtCandidates &&
      appointment.startedAtCandidates.length > 0
    ) {
      let expired = true;
      appointment.startedAtCandidates.forEach((candidate) => {
        if (dayjs(candidate).isAfter(now)) {
          expired = false;
        }
      });
      return expired
        ? AppointmentStatus.PENDING_EXPIRED
        : AppointmentStatus.PENDING;
    }
    return AppointmentStatus.PENDING;
  }
  const startedAt = dayjs(appointment.startedAt);
  const endedAt = dayjs(appointment.endedAt);
  if (startedAt.isBefore(now) && endedAt.isAfter(now)) {
    return AppointmentStatus.IN_PROGRESS;
  }
  if (startedAt.isBefore(now)) {
    return AppointmentStatus.EXPIRED;
  }
  return AppointmentStatus.CONFIRMED;
};

export const getSurveyLinkByAppointment = (
  appointment: IAppointment,
  doctors?: MedicalcareDoctor[],
  pharmacies?: Pharmacy[],
): { surveyLink: string | undefined; shouldShowSurveyLink: boolean } => {
  const appointmentStatus = getAppointmentStatus(appointment);
  const shouldShowSurveyLink =
    appointmentStatus === AppointmentStatus.CONFIRMED ||
    appointmentStatus === AppointmentStatus.IN_PROGRESS;
  if (appointment.appointmentType === AppointmentType.medicalcare) {
    const doctor = doctors?.find((d) => d.userId === appointment.doctorUserID);
    if (doctor) {
      const department = doctor.departmentsInfo.find(
        (d) => d.name === appointment.doctorDepartment,
      );
      if (department) {
        return { surveyLink: department.url, shouldShowSurveyLink };
      }
    }
  }
  if (appointment.appointmentType === AppointmentType.medicine_delivery) {
    const pharmacy = pharmacies?.find(
      (p) => p.userId === appointment.doctorUserID,
    );
    if (pharmacy) {
      return { surveyLink: pharmacy.url, shouldShowSurveyLink };
    }
  }
  return { surveyLink: undefined, shouldShowSurveyLink };
};
